export default __webpack_public_path__ + "static/media/physician.c5bfddf9.svg";